
window.Vue = require('vue');
window.Vuex = require('vuex');
window.Vue.use(window.Vuex);

import vuex from 'vuex'
import claims from './modules/claims'
import favourites from './modules/favourites'
import recent_searches from './modules/recent_searches'
import auto_notices from './modules/auto_notices'
import saved_searches from './modules/saved_searches'
import auction_search from './modules/auction_search'
import companies from './modules/companies'
import currency from './modules/currency'
import market_research from './modules/market_research'
import mygarage from './modules/mygarage'
import myrecommendations from './modules/myrecommendations'
import recommendedvehicle from './modules/recommendedvehicle'
import recommended from './modules/recommended'
import users from './modules/users'
import addressBook from './modules/addressBook'
import loadVehicleForEmail from './modules/loadVehicleForEmail'
import favouriteTags from './modules/favouriteTags'
import bidFavourites from './modules/bidFavourites'
import userBids from './modules/userBids'
import countries from './modules/countries'
import priceRule from './modules/priceRule'
import region from './modules/region'
import userStatuses from './modules/userStatuses'
import attendedAuctions from './modules/attendedAuctions'
import category from './modules/category'
import userRoles from './modules/userRoles'
import vehicleStock from './modules/vehicleStock'
import vehicleStockRequests from './modules/vehicleStockRequests'
import usersHistory from './modules/usersHistory'
import notifications from './modules/notifications'
import auction_nextprev from './modules/auction_nextprev'
import stock_nextprev from './modules/stock_nextprev'
import vehicleViews from './modules/vehicleViews'
import emailRecord from './modules/emailRecord'
import claimStatuses from './modules/claimStatuses'



const debug = process.env.NODE_ENV !== 'production';
const state = {
};
export default new vuex.Store({
    modules: {
        claims,
        favourites,
        recent_searches,
        saved_searches,
        auto_notices,
        market_research,
        auction_search,
        mygarage,
        currency,
        companies,
        myrecommendations,
        stock_nextprev,
        auction_nextprev,
        recommendedvehicle,
        recommended,
        bidFavourites,
        users,
        addressBook,
        loadVehicleForEmail,
        favouriteTags,
        userBids,
        countries,
        priceRule,
        region,
        userStatuses,
        attendedAuctions,
        category,
        vehicleStock,
        vehicleStockRequests,
        userRoles,
        usersHistory,
        notifications,
        vehicleViews,
        emailRecord,
        claimStatuses,
    },
    state,
    strict: debug,
})



// WEBPACK FOOTER //
// ./resources/js/store/index.js